module.exports = __webpack_public_path__ + "img/securityImg1.8d8c01c2.png";